import script from "./BirthdayLeaveWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BirthdayLeaveWidget.vue?vue&type=script&setup=true&lang=js"

import "./BirthdayLeaveWidget.vue?vue&type=style&index=0&id=6f32da13&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f32da13"]])

export default __exports__